import { AxiosHttpClient } from './axios-http-client';
import { HttpClient } from './http';

export const httpClient: HttpClient = new AxiosHttpClient();
